/* ---- product form ---- */
if (!customElements.get("product-form")) {
  customElements.define("product-form", class $ extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.formIdInput = this.form.querySelector("[name=id]");
      this.formIdInput.disabled = false;
      this.isMain = this.classList.contains("main-product-form");
      this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
      this.skipCart = this.formIdInput.dataset.skipCart === "true";
      this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      this.isCartUpsell = this.dataset.isCartUpsell === "true";
      this.submitButton = this.querySelector("[type=\"submit\"]");
      if (document.querySelector("cart-drawer")) {
        if (this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
        this.hasDrawer = true;
      }
      if (this.submitButton) {
        this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
      }
      this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
      this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
      this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
      this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
      if (this.quantityBreaks) {
        this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells");
      }
      this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
      this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
      this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
      this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
      this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit($) {
      let x = null;
      let e = false;
      if ($) {
        $.preventDefault();
        if ($.currentTarget.classList.contains("button--has-spinner")) {
          (x = $.currentTarget).classList.add("loading");
        }
        if ($.currentTarget.dataset.skipCartButton === "true") {
          e = true;
        }
      }
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", true);
      if (!x) {
        this.submitButton.classList.add("loading");
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove("hidden");
        }
      }
      this.additionalAtcButtons.forEach($ => {
        $.setAttribute("disabled", "");
      });
      if (this.displayedSubmitButton) {
        this.displayedSubmitButton.setAttribute("disabled", "");
        this.displayedSubmitButton.classList.add("loading");
      }
      let i = false;
      let s = false;
      if (this.variantInputs && !this.ref) {
        this.variantInputs.innerHTML = "";
        let a = "";
        let r = [];
        let n = new Set();
        let l = $ => {
          let x = $ == null ? "" : String($).trim();
          if (x === "") {
            return null;
          } else {
            return x;
          }
        };
        let h = ($, x = 1, e = null) => {
          if (!$) {
            return;
          }
          let s = String($);
          let a = Number(x) || 1;
          let n = l(e);
          let h = r.findIndex($ => {
            let t = l($.selling_plan);
            return $.id === s && t === n;
          });
          if (h === -1) {
            let c = {
              id: s,
              quantity: a
            };
            if (n) {
              c.selling_plan = n;
            }
            r.push(c);
          } else {
            r[h].quantity += a;
          }
        };
        let c = $ => {
          if ($) {
            n.add(String($));
          }
        };
        if (!!this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
          this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach($ => {
            if ($.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + $.dataset.handle)) {
              let e = $.querySelector("input[name=\"selling_plan\"]")?.value || null;
              h($.dataset.id, 1, e);
            }
          });
        }
        if (this.bundleDeals) {
          if (this.dataset.includePdpUpsells === "true") {
            document.querySelectorAll("product-info-upsell").forEach($ => {
              let e = $.querySelector("input[name=\"selling_plan\"]")?.value || null;
              if ($.dataset.selected === "true") {
                h($.dataset.id, 1, e);
              }
            });
          }
          (this.bundleDeals.formVariants || []).forEach($ => {
            if ($) {
              h($.id, Number($.quantity) || 1);
            }
          });
        } else {
          if (this.quantityGifts && Array.isArray(this.quantityGifts.unlockedItems) && this.quantityGifts.unlockedItems.length > 0) {
            this.quantityGifts.unlockedItems.forEach($ => h($, 1));
          }
          this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
          for (let d = this.upsells.length - 1; d >= 0; d--) {
            let o = this.upsells[d];
            if (o && o.dataset.selected === "true") {
              let f = o.querySelector("input[name=\"selling_plan\"]")?.value || null;
              h(o.dataset.id, 1, f);
            }
          }
          if (this.quantityBreakUpsells) {
            this.quantityBreakUpsells.forEach($ => {
              ($.unlockedItems || []).forEach($ => {
                let e = String($);
                if (!r.some($ => String($.id) === e)) {
                  h(e, 1);
                }
              });
            });
          }
          if (this.mainBundleItems.length === 0) {
            if (this.quantityBreaks && Array.isArray(this.quantityBreaks.formVariants) && this.quantityBreaks.formVariants.length > 0) {
              this.quantityBreaks.formVariants.forEach($ => {
                h($, 1);
                c($);
              });
              s = true;
            } else {
              let u = 1;
              if (this.quantityBreaks) {
                u = Number(this.quantityBreaks.selectedQuantity) || 1;
              } else if (this.quantityPicker) {
                u = Number(this.quantityPicker.querySelector(".quantity__input")?.value) || 1;
              } else if (this.querySelector("input[name=\"quantity\"]")) {
                u = Number(this.querySelector("input[name=\"quantity\"]").value) || 1;
              }
              let b = this.formIdInput.value;
              h(b, u);
              c(b);
            }
          }
          for (let p = this.mainBundleItems.length - 1; p >= 0; p--) {
            let _ = this.mainBundleItems[p];
            h(_.dataset.id, 1);
            if (_.dataset.isMainPdpProduct === undefined || _.dataset.isMainPdpProduct === "true") {
              c(_.dataset.id);
            }
          }
        }
        if (r.length > 1 || s || this.bundleDeals || this.mainBundleItems.length > 0) {
          let m = [];
          this.customFields?.forEach($ => {
            if ($?.dataset?.disabled !== "true") {
              m.push({
                fieldName: $.fieldName,
                value: $.prevValue
              });
            }
          });
          let y = null;
          if (this.classList.contains("main-product-form")) {
            y = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"], skio-plan-picker [name=\"selling_plan\"]");
          }
          let g = this.querySelector("#simple-bundles-io-options");
          let v = "input[name^=\"properties[\"]:not(#validator):not(.shrine-property-input):not([type=\"radio\"]),input[name^=\"properties[\"][type=\"radio\"]:checked:not(#validator):not(.shrine-property-input),select[name^=\"properties[\"]:not(#validator):not(.shrine-property-input)";
          let S = this.classList.contains("main-product-form") ? this.productInfo ? this.productInfo.querySelectorAll(v) : document.querySelectorAll(v) : [];
          r.forEach($ => {
            if (n.has($.id)) {
              let e = [];
              m.forEach($ => {
                e.push({
                  fieldName: $.fieldName,
                  value: $.value
                });
              });
              if (g) {
                g.querySelectorAll("select[name^=\"properties[\"], input[name^=\"properties[\"]").forEach($ => {
                  let i = $.name.match(/properties\[(.*?)\]/);
                  if (i) {
                    e.push({
                      fieldName: i[1],
                      value: $.value
                    });
                  }
                });
              }
              if (this.classList.contains("main-product-form")) {
                S.forEach($ => {
                  let i = $.name.match(/properties\[(.*?)\]/);
                  if (i) {
                    if ($.type === "file") {
                      if ($.files && $.files.length > 0) {
                        e.push({
                          fieldName: i[1],
                          value: $.files[0],
                          isFile: true
                        });
                      }
                    } else {
                      e.push({
                        fieldName: i[1],
                        value: $.value
                      });
                    }
                  }
                });
              }
              if (e.length) {
                $.properties = e;
              }
              if (y && typeof y.value === "string" && y.value.length > 0) {
                $.selling_plan = y.value;
              }
            }
          });
          let k = document.createDocumentFragment();
          let T = [];
          r.forEach(($, x) => {
            a += "<input type=\"hidden\" name=\"items[" + x + "][quantity]\" value=\"" + $.quantity + "\">" + ("<input type=\"hidden\" name=\"items[" + x + "][id]\" value=\"") + $.id + "\">";
            if ($.selling_plan) {
              a += "<input type=\"hidden\" name=\"items[" + x + "][selling_plan]\" value=\"" + $.selling_plan + "\">";
            }
            if (Array.isArray($.properties) && $.properties.length) {
              $.properties.forEach($ => {
                if ($.isFile) {
                  T.push({
                    name: "items[" + x + "][properties][" + $.fieldName + "]",
                    file: $.value
                  });
                } else {
                  let i = document.createElement("input");
                  i.type = "hidden";
                  i.name = "items[" + x + "][properties][" + $.fieldName + "]";
                  i.value = serializePropValue($.value);
                  k.appendChild(i);
                }
              });
            }
          });
          this._filePropsForFormData = T;
          this.variantInputs.innerHTML = a;
          this.variantInputs.appendChild(k);
          i = true;
        }
      }
      var E = fetchConfig("javascript");
      E.headers["X-Requested-With"] = "XMLHttpRequest";
      delete E.headers["Content-Type"];
      var B = new FormData(this.form);
      if (this._filePropsForFormData && this._filePropsForFormData.length > 0) {
        this._filePropsForFormData.forEach(({
          name: $,
          file: x
        }) => {
          B.append($, x);
        });
        this._filePropsForFormData = [];
      }
      if (this.ref) {
        i = true;
      }
      if (this.cart) {
        B.append("sections", this.cart.getSectionsToRender().map($ => $.id));
        B.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (i) {
        let C = this.dataset.options ? this.dataset.options.split(",") : [];
        let q = ["id", "quantity", ...C];
        for (let I = 0; I < q.length; I++) {
          B.delete(q[I]);
        }
      }
      E.body = B;
      fetch("" + routes.cart_add_url, E).then($ => $.json()).then(async $ => {
        if ($.status) {
          this.handleErrorMessage($.description);
          let i = this.submitButton.querySelector(".sold-out-message");
          if (!i) {
            return;
          }
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          i.classList.remove("hidden");
          this.error = true;
          return;
        }
        if (!$.sections && this.cart) {
          try {
            let s = await fetch(routes.cart_url + "?sections=" + this.cart.getSectionsToRender().map($ => $.id).join(","));
            let a = await s.json();
            $.sections = a;
          } catch (r) {
            console.error("Add to cart fallback failed", r);
            this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
            return;
          }
        }
        if (this.skipCart || e) {
          window.location = "/checkout";
          return;
        }
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.formIdInput.id,
            cartData: $
          });
        }
        this.error = false;
        let n = this.closest("quick-add-modal");
        if (n) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents($, this.isCartUpsell);
            });
          }, {
            once: true
          });
          n.hide(true);
        } else {
          this.cart.renderContents($, this.isCartUpsell);
        }
      }).catch($ => {
        console.error($);
      }).finally(() => {
        if (x) {
          x.classList.remove("loading");
        } else {
          this.submitButton.classList.remove("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
        }
        this.additionalAtcButtons.forEach(t => {
          t.removeAttribute("disabled");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.removeAttribute("disabled");
          this.displayedSubmitButton.classList.remove("loading");
        }
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        if (!this.error) {
          this.submitButton.removeAttribute("aria-disabled");
        }
      });
    }
    handleErrorMessage($ = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (this.errorMessageWrapper) {
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !$);
        if ($) {
          this.errorMessage.textContent = $;
        }
      }
    }
  });
}
